import React, { Component } from 'react';


class About extends Component {
  render() {
    return (
      <div>
        <p style={{ width: '75%', margin: 'auto', paddingTop: '1em' }}>
          First off what I think is important to know about me is I like to learn and build stuff.
          I spend most of my spare time building something or programming. I have over 4 years of 
          experiences as a Software/Research Engineer working in a fast growing company.
          I have experience building CAD/CAM software for the manufacturing industry, HVAC controls,
          image processing, and inventory tracking systems. My ideal job is one in which I can interact
          with my users, learn new things, and gain experience with architecure and poject management. 
        </p>
      </div>
    )
  }
}

export default About;
